import i18next from 'i18next';
import { useResponseHandler } from 'utils/service/responseHandler';
import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import { apiClient } from 'utils';

export const usePutForcePasswordChange = (userId: string) => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('usePutForcePasswordChange');

  return useMutation<any, DefaultError, string>({
    async mutationFn(body: string) {
      loading(i18next.t('service-message.auth.force-password-reset.loading'));

      const response = await apiClient({
        method: 'PUT',
        url: 'Auth/ForcePasswordChange',
        body: { userId },
      });

      return responseHandler(response, {
        groupName: 'usePutForcePasswordChange',
      });
    },
    onError: dismiss,
    onSuccess(data) {
      success(i18next.t('service-message.auth.force-password-reset.success'));
    },
  });
};
